import { mdiCog } from "@mdi/js";
import Icon from "@mdi/react";
import { useNavigate } from "react-router-dom";

export function SettingsButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/edit-profile");
  };

  return (
    <button
      className="btn btn-secondary position-fixed rounded-circle d-flex align-items-center justify-content-center"
      style={{
        bottom: "20px",
        left: "20px",
        width: "50px",
        height: "50px",
        zIndex: 1000,
        padding: 0,
      }}
      onClick={handleClick}
      title="Configurações"
    >
      <Icon path={mdiCog} size={1.2} color="white" />
    </button>
  );
}